import { render } from "./DetailRight.vue?vue&type=template&id=6af738b6&scoped=true"
import script from "./DetailRight.vue?vue&type=script&lang=js"
export * from "./DetailRight.vue?vue&type=script&lang=js"

import "./DetailRight.vue?vue&type=style&index=0&id=6af738b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af738b6"]])

export default __exports__